// @flow
import React from "react";

import Icon, { type IconProps } from "../";

export default function Wallet({
  fill = "currentColor",
  width = "17px",
  ...props
}: IconProps) {
  return (
    <Icon
      
      viewBox="0 0 17.574 16.197"
      fill={fill}
      width={width}
      {...props}
    >
      <path
        d="M-5152.823-2891.833a1.178,1.178,0,0,1-1.177-1.178v-10.641a1.177,1.177,0,0,1,1.177-1.177h14.6a1.177,1.177,0,0,1,1.176,1.177v2.527h-4.051a1.528,1.528,0,0,0-1.527,1.526v2.537a1.529,1.529,0,0,0,1.527,1.527h4.051v2.526a1.178,1.178,0,0,1-1.176,1.178Zm11.727-4.54a.69.69,0,0,1-.69-.69v-2.537a.69.69,0,0,1,.69-.69h3.979a.691.691,0,0,1,.69.69v2.537a.691.691,0,0,1-.69.69Zm.375-1.958a1,1,0,0,0,1,1,1,1,0,0,0,1-1,1,1,0,0,0-1-1A1,1,0,0,0-5140.722-2898.332Zm-7.455-7.645,5.983-1.976a1.52,1.52,0,0,1,1.92.966l.333,1.01Z"
        transform="translate(5154 2908.03)"
      />
    </Icon>
  );
}

export function WalletPlus({
  fill = "currentColor",
  width = "28px",
  ...props
}: IconProps) {
  return (
    <Icon
      
      viewBox="0 0 28.001 18.852"
      width={width}
      fill={fill}
      {...props}
    >
      <path
        d="M-12095.176-27.148a16.515,16.515,0,0,1-4.6-.575c-1.283-.4-1.545-.8-1.545-.891l-.03-1.77a7.634,7.634,0,0,0,1.509.55,18.53,18.53,0,0,0,4.549.523,17.989,17.989,0,0,0,5.006-.636,7.636,7.636,0,0,0,1.271-.517v1.819c.007.066-.233.49-1.551.9A16.2,16.2,0,0,1-12095.176-27.148Zm-15.787-1.256a6.042,6.042,0,0,1-4.464-1.974,6,6,0,0,1-1.567-4.35,6,6,0,0,1,1.966-4.183,6.086,6.086,0,0,1,4.065-1.569,6.142,6.142,0,0,1,1.788.268,6.085,6.085,0,0,1,4.133,4.553,6.255,6.255,0,0,1,.122,1.216,6.024,6.024,0,0,1-1.977,4.467A6.026,6.026,0,0,1-12110.963-28.4Zm-4.038-6.843v2h3v3h2v-3h3v-2h-3v-3h-2v3Zm12.45,5.65h0a18.921,18.921,0,0,1-2.806-.249,7.2,7.2,0,0,0,1.164-1.992c.515.043,1.05.073,1.606.079v.109l.036,2.052Zm7.266-.934c-3.455,0-5.641-.786-6.089-1.344l-.006-.508-.024-1.4a7.418,7.418,0,0,0,1.319.511,18,18,0,0,0,4.806.587,18.2,18.2,0,0,0,4.951-.617,6.894,6.894,0,0,0,1.328-.517v1.606a1.008,1.008,0,0,0-.042.2c0,.082-.283.5-1.594.9A16.74,16.74,0,0,1-12095.285-30.53Zm-7.32-2.448h0c-.423,0-.842-.018-1.24-.055a7.3,7.3,0,0,0,.137-1.417c0-.237-.012-.471-.027-.715.351.024.721.036,1.1.043l.036,2.143Zm7.332-.9a16.836,16.836,0,0,1-4.465-.538c-1.239-.364-1.651-.762-1.7-.921.054-.235.538-.628,1.73-.964a16.6,16.6,0,0,1,4.321-.514h.1a17.093,17.093,0,0,1,4.665.575c1.3.393,1.594.793,1.6.879s-.3.515-1.651.915A16.819,16.819,0,0,1-12095.273-33.875Zm-6.974-2.454h-.061c-.584,0-1.146-.024-1.666-.061a7.185,7.185,0,0,0-1.086-2.253,21.871,21.871,0,0,0,2.746.176,18.141,18.141,0,0,0,5.023-.636,7.634,7.634,0,0,0,1.308-.523v1.587c-2.335.066-5.206.548-6.264,1.709Zm-.055-3.357a17.294,17.294,0,0,1-4.127-.453,7.839,7.839,0,0,0-1.946-1.086l-.042-1.709a6.668,6.668,0,0,0,1.311.5,17.983,17.983,0,0,0,4.8.587,18.075,18.075,0,0,0,5.015-.636,7.155,7.155,0,0,0,1.317-.529v1.587a.32.32,0,0,0-.061.228c0,.112-.295.522-1.606.919A17.063,17.063,0,0,1-12102.3-39.687Zm-.006-3.357a16.557,16.557,0,0,1-4.464-.544c-1.309-.374-1.671-.792-1.7-.921,0-.16.33-.529,1.557-.9a16.436,16.436,0,0,1,4.607-.587,16.961,16.961,0,0,1,4.665.587c1.32.4,1.605.811,1.605.891s-.287.5-1.611.9A17.1,17.1,0,0,1-12102.308-43.044Z"
        transform="translate(12117.001 46)"
      />
    </Icon>
  );
}



// WEBPACK FOOTER //
// ./src/components/Icons/Tournaments/Wallet.js